import { EChatModalActionType, IOpenChatModalPayload } from './types';
import { TThunkAction } from '../../types/redux';
import { actionGenerator } from '../../utils/redux/actionGenerator';

const openChatModalAction = actionGenerator<EChatModalActionType.Open, IOpenChatModalPayload>(
  EChatModalActionType.Open,
);
const openChatModalAfterAuthAction = actionGenerator<EChatModalActionType.OpenAfterAuth, IOpenChatModalPayload>(
  EChatModalActionType.OpenAfterAuth,
);
const closeChatModalAction = actionGenerator<EChatModalActionType.Close>(EChatModalActionType.Close);

export const openChatModal =
  (payload: IOpenChatModalPayload): TThunkAction =>
  async dispatch => {
    dispatch(openChatModalAction(payload));

    window.history.pushState({}, '');
    window.addEventListener(
      'popstate',
      () => {
        dispatch(closeChatModalAction());
      },
      { once: true },
    );
  };

export const openChatModalAfterAuth =
  (payload: IOpenChatModalPayload): TThunkAction =>
  async dispatch => {
    dispatch(openChatModalAfterAuthAction(payload));

    window.history.pushState({}, '');
    window.addEventListener(
      'popstate',
      () => {
        dispatch(closeChatModalAction());
      },
      { once: true },
    );
  };

export const closeChatModal = (): TThunkAction => async dispatch => {
  dispatch(closeChatModalAction());
  window.history.back();
};
